import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useFetchCLForActiveVariant } from '../../hooks/use-fetch-cl-for-active-variant.js';
import { NoRxSelectionColumn } from './NoRxSelectionColumn.js';

const NoRxSelectionColumnContainer = (props)=>{
    const { eyeSideId  } = props;
    // Fetch the CL variant for the active variant and selected prescription
    useFetchCLForActiveVariant({
        eyeSide: eyeSideId
    });
    return /*#__PURE__*/ React.createElement(NoRxSelectionColumn, swcHelpers.extends({}, props));
};

export { NoRxSelectionColumnContainer };
//# sourceMappingURL=NoRxSelectionColumnContainer.js.map
